import { createSlice } from "@reduxjs/toolkit";
import { AddUOM, UpdateUOM, GetUOMs } from "services/other/uom.service";
import { toast } from 'react-toastify';

export const uomListSlice = createSlice({
  name: "uomList",
  initialState: {
    uomList: [],
    uomListLoading: false,
    uomListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetUOMs.pending, (state) => {
      state.uomListLoading = true
    });

    builder.addCase(GetUOMs.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.uomList = action.payload
      state.uomListLoading = false
      state.uomListError = null
    });

    builder.addCase(GetUOMs.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.uomListLoading = false
      state.uomListError = action.error?.message
    });
  },
});

export const uomAddSlice = createSlice({
  name: "uomAdd",
  initialState: {
    uomAdd: {},
    uomAddLoading: false,
    uomAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddUOM.pending, (state) => {
      // toast.loading('We are adding the uom 🤯')
      state.uomAddLoading = true
    });

    builder.addCase(AddUOM.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New uom added successfully 👌');

      state.uomAdd = action.payload
      state.uomAddLoading = false
      state.uomAddError = null
    });

    builder.addCase(AddUOM.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the uom 😣")

      state.uomAddLoading = false
      state.uomAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const uomUpdateSlice = createSlice({
  name: "uomUpdate",
  initialState: {
    uomUpdate: {},
    uomUpdateLoading: false,
    uomUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateUOM.pending, (state) => {
      // toast.loading('We are updating the uom 🤯')
      state.uomUpdateLoading = true
    });

    builder.addCase(UpdateUOM.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('UOM update successfully 👌');

      state.uomUpdate = action.payload
      state.uomUpdateLoading = false
      state.uomUpdateError = null
    });

    builder.addCase(UpdateUOM.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the uom 😣")

      state.uomUpdateLoading = false
      state.uomUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});
